import { CategoryCard } from './CategoryCard';
import { shopByPopularCategories } from './PopularCategories';

export const Lifestyle = () => {
  return (
    <CategoryCard
      image={shopByPopularCategories[2].image}
      description={shopByPopularCategories[2].desc}
      title={shopByPopularCategories[2].title}
      link={shopByPopularCategories[2].link}
      buttonText="SHOP NOW"
      maxImageWidth="300px"
    />
  );
};
